import React, { useMemo } from "react";
import AddShoppingCartOutlinedIcon from "@material-ui/icons/AddShoppingCartOutlined";
import DeleteIcon from "@material-ui/icons/Delete";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import PaymentOutlinedIcon from "@material-ui/icons/PaymentOutlined";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import ConfirmModalContent from "../../../components/confirm-modal-content";
import DataTable from "../../../components/data-table";
import { currencyFormat } from "../../../helpers";
import ordersService from "../../../services/orders.service";
import FormModalContent from "../orders/form";
import OrderStatusBadge from "../orders/status-badge";
import InPersonPaymentForm from "./payment-form";

const defaultKeys = [
  {
    field: "trackingCode",
    title: "کد رهگیری",
    active: true,
  },
  {
    field: "user.phoneNumber",
    title: "شماره تلفن",
    active: true,
  },
];

export default function InPersonOrdersPage() {
  const { initials } = useSelector((state) => state.app);
  const history = useHistory();

  const deleteItem = (item) => {
    return ordersService.deleteOrder(item.id);
  };

  const headerCells = useMemo(
    () => [
      {
        field: "trackingCode",
        title: "کد رهگیری",
        disableSort: true,
      },
      {
        field: "user",
        title: "نام مشتری",
        renderer: (v) => <span>{v?.fullName || "-"}</span>,
      },
      {
        field: "user",
        title: "شماره تماس",
        renderer: (v) => <span className="en">{v?.phoneNumber || "-"}</span>,
      },
      {
        field: "status",
        title: "وضعیت",
        disableSort: true,
        renderer: (v) => <OrderStatusBadge status={v} initials={initials} />,
      },
      {
        field: "totalAmount",
        title: "مبلغ کل",
        renderer: (v) => currencyFormat(v || 0),
      },
      {
        field: "depositAmount",
        title: "بیعانه/پرداخت‌شده",
        renderer: (v) => currencyFormat(v || 0),
      },
      {
        field: "remainingAmount",
        title: "مانده",
        renderer: (v) => currencyFormat(v || 0),
      },
      {
        field: "createDate",
        title: "تاریخ ایجاد",
        date: true,
      },
    ],
    [initials]
  );

  return (
    <div className="p-3">
      <DataTable
        headCells={headerCells}
        searchKeys={defaultKeys}
        actions={[
          {
            tooltip: "ثبت خرید حضوری جدید",
            icon: <AddShoppingCartOutlinedIcon />,
            onClick: () => history.push("/admin/in-person-purchase"),
          },
        ]}
        rowActions={[
          {
            modalProps: { maxWidth: "md" },
            tooltip: "مشاهده جزئیات",
            icon: <InfoOutlinedIcon />,
            modalContent: (props) => <FormModalContent {...props} />,
          },
          {
            modalProps: { maxWidth: "sm" },
            tooltip: "ثبت پرداخت مانده",
            icon: <PaymentOutlinedIcon />,
            hidden: (row) => Number(row.remainingAmount || 0) <= 0,
            modalContent: (props) => <InPersonPaymentForm {...props} />,
          },
          {
            modalProps: { maxWidth: "sm" },
            tooltip: "حذف خرید",
            icon: <DeleteIcon />,
            modalContent: (props) => (
              <ConfirmModalContent
                onConfirm={() => deleteItem(props.data)}
                confirmText={props.data.trackingCode}
                close={props.close}
              />
            ),
          },
        ]}
        backend={`${ordersService.getOrdersUrl}?orderType=inPerson`}
        title="لیست خریدهای حضوری"
        order={{ order: "DESC", orderBy: "createDate" }}
      />
    </div>
  );
}
